import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dcc-action-modal',
  templateUrl: './action-modal.component.html',
  styleUrls: ['./action-modal.component.scss'],
})
export class ActionModalComponent {
  @Input() config: ActionModalConfig;

  constructor(private activeModal: NgbActiveModal) {}

  close(actionClicked = false) {
    const result = { success: actionClicked };
    this.activeModal.close(result);
  }

  onActionClick() {
    this.close(true);
  }
}

export interface ActionModalConfig {
  title: string;
  body: string;
  action: string;
}

export interface ActionModalResult {
  success: boolean;
}
